// Localização: frontend/src/components/Prontuario/ProfissionalHeader.jsx (versão 1.0.0)
// Componente de cabeçalho do prontuário do profissional

import React from 'react';
import { getUsuarioFotoUrl } from '../../utils/imageUtils';
import { formatDate } from '../../utils/formatters';

/**
 * Componente de cabeçalho do prontuário do profissional
 * Exibe informações básicas, foto e KPIs
 */
const ProfissionalHeader = ({ profissionalId, prontuarioData, onRefresh }) => {
    if (!prontuarioData || !prontuarioData.profissional) {
        return (
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 md:p-6">
                <div className="flex items-center justify-between">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900">Carregando...</h1>
                    </div>
                </div>
            </div>
        );
    }

    const profissional = prontuarioData.profissional;
    const estatisticas = prontuarioData.estatisticas || {};

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 md:p-6">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                {/* Informações do Profissional */}
                <div className="flex items-center gap-4">
                    {/* Foto do Profissional */}
                    <div className="flex-shrink-0">
                        <img
                            src={getUsuarioFotoUrl(profissional.fotoURL)}
                            alt={profissional.nome_completo || 'Profissional'}
                            className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover border-2 border-teal-200"
                            onError={(e) => {
                                e.target.src = '/default-avatar.png';
                            }}
                        />
                    </div>

                    {/* Dados Básicos */}
                    <div className="flex-1 min-w-0">
                        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 truncate">
                            {profissional.nome_completo || 'Nome não informado'}
                        </h1>
                        <div className="mt-1 flex flex-wrap items-center gap-2 text-sm text-gray-600">
                            {profissional.role && (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-teal-100 text-teal-800">
                                    {profissional.role}
                                </span>
                            )}
                            {profissional.email && (
                                <span className="truncate">{profissional.email}</span>
                            )}
                        </div>
                        <div className="mt-2 flex flex-wrap gap-4 text-sm text-gray-500">
                            {profissional.crm && (
                                <span>CRM: {profissional.crm}</span>
                            )}
                            {profissional.coren && (
                                <span>COREN: {profissional.coren}</span>
                            )}
                            {profissional.data_admissao && (
                                <span>Admissão: {formatDate(profissional.data_admissao)}</span>
                            )}
                        </div>
                    </div>
                </div>

                {/* KPIs e Estatísticas */}
                <div className="flex flex-wrap gap-4 md:gap-6">
                    {estatisticas.agendamentos && (
                        <div className="text-center">
                            <div className="text-2xl font-bold text-teal-600">
                                {estatisticas.agendamentos.total_agendamentos || 0}
                            </div>
                            <div className="text-xs text-gray-500 mt-1">Agendamentos</div>
                        </div>
                    )}
                    {estatisticas.tarefas && (
                        <div className="text-center">
                            <div className="text-2xl font-bold text-teal-600">
                                {estatisticas.tarefas.total_tarefas || 0}
                            </div>
                            <div className="text-xs text-gray-500 mt-1">Tarefas</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProfissionalHeader;

